export default "__VITE_ASSET__CVFrHnO9__"